import isNull from "../../utils/NullChecking";
const DeleteReduxDropDown = (ID, DropDown, otherCase) => {
       
        let UpdateDropDown = []
        if (otherCase === 'BILLINGSTATUS') {
                UpdateDropDown = DropDown.filter(item => item.BillingStatusID + "" !== ID + "");
        } else {
                UpdateDropDown = DropDown.filter(item => item.value + "" !== ID + "");
        }

        return UpdateDropDown;
}
export default DeleteReduxDropDown;